const SemVer = require('../classes/semver')
const minor = (a, loose) => new SemVer(a, loose).minor
module.exports = minor



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/minor.js
// module id = 2188
// module chunks = 0